module.exports = __webpack_public_path__ + "static/img/aepic-25-2.2f62efc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/aepic/aepic-25-2.jpg
// module id = 5BKd
// module chunks = 51